import axios from '../../axios/axios';
import ipAddress from '../../axios/ipAddress' //域名
import QS from 'qs'; //序列化

/**
 * 员工相关接口
 */
const staff = {

      /**
       * 员工列表
       */
      staffList(page){
         return axios.post(ipAddress.qi+'/admin/a1/staff/page',page,true)
      },
      //选择部门后权限
      deptList(id){
         return axios.post(ipAddress.qi+'/admin/a1/cms-role/listGroupByDept',QS.stringify({
            id:id
        }),false)
      },
      //添加员工
      addStaff(form){
         return axios.post(ipAddress.qi+'/admin/a1/staff/save',form,true)
      },
      //员工详情
      staffInfo(id){
         return axios.post(ipAddress.qi+'/admin/a1/staff/getById',QS.stringify({
            id:id
        }),false)
      },
      //编辑员工
      staffUpdate(form){
         return axios.post(ipAddress.qi+'/admin/a1/staff/upById',form,true)
      },
      //删除员工
      staffDelete(id){
         return axios.post(ipAddress.qi+'/admin/a1/staff/delById',QS.stringify({
            id:id
        }),false)
      },
      //移交员工
      staffTurnOver(form){
         return axios.post(ipAddress.qi+'/admin/a1/staff/turnOverByCode',form,true)
      },
}
export default staff;


// WEBPACK FOOTER //
// ./src/js/staff/staff.js